// name, lat, lng, minZoom, maxZoom

const berlin = [
  ['Mitte', 52.531658, 13.359605, 0, 20],
  ['Friedrichshain-Kreuzberg', 52.504438, 13.405846, 10, 20],
  ['Pankow', 52.590782,13.426418, 10, 20],
  ['Charlottenburg-Wilmersdorf', 52.500851, 13.238246, 0, 20],
  ['Spandau', 52.538390, 13.169292, 10, 20],
  ['Steglitz-Zehlendorf', 52.449815, 13.234452, 10, 20],
  ['Tempelhof-Schöneberg', 52.458516,13.369986, 0, 20],
  ['Neukölln', 52.467277, 13.431979, 10, 20],
  ['Treptow-Köpenick', 52.444187, 13.580461, 0, 20],
  ['Marzahn-Hellersdorf', 52.529560, 13.557446, 10, 20],
  ['Lichtenberg', 52.529500, 13.468593, 0, 20],
  ['Reinickendorf', 52.594967, 13.255966, 0, 20]
];

const hamburg = [
  ['Bergedorf', 53.4893431,10.1837658, 0, 20],
  ['Billstedt', 53.5421505,10.1309877, 0, 20],
  ['Blankenese', 53.5632049,9.794358, 10, 20],
  ['Eppendorf', 53.5926569,9.9841016, 10, 20],
  ['Harburg', 53.4618865,9.9848546, 10, 20],
  ['Kirchwerder', 53.4283454,10.1424865, 10, 20],
  ['Altona', 53.578866, 9.876486, 0, 20],
  ['Neuenfelde', 53.5161729,9.7992219, 0, 20],
  ['Neugraben-Fischbek', 53.4628017,9.8031153, 0, 20],
  ['Niendorf', 53.6278245,9.9521746, 0, 20],
  ['Poppenbüttel', 53.6586233,10.0824929, 0, 20],
  ['Rahlstedt', 53.6082099,10.1726856, 10, 20],
  ['St. Pauli', 53.5533225,9.9739845, 10, 20],
  ['Wilhelmsburg', 53.4900723,10.00773, 0, 20],
  ['Wandsbek', 53.585645, 10.087434, 10, 20],
  ['Eimsbüttel', 53.577817, 9.960671, 10, 20],
  ['Sternschanze', 53.563048, 9.965782, 10, 20],
  ['Hafencity', 53.541865, 9.995398, 0, 20],
  ['Veddel', 53.518471, 10.039851, 10, 20],
  ['Ohlsdorf', 53.620341, 10.043258, 10, 20]
];

const nrw = [
  ['Dortmund', 51.5079705,7.4002232, 0, 20],
  ['Essen', 51.4524323,6.9994233, 0, 20],
  ['Duisburg', 51.4426793,6.6907533, 10, 20],
  ['Wuppertal', 51.2551953,7.1227903, 10, 20],
  ['Köln', 50.9368244,6.9177093, 0, 20],
  ['Bonn', 50.7346484,7.0794273, 0, 20],
  ['Aachen', 50.7735554,6.0637903, 0, 20],
  ['Bielefeld', 52.0269223,8.5026593, 10, 20],
  ['Paderborn', 51.7175883,8.7346483, 0, 20],
  ['Siegen', 50.8822224,7.9920503, 0, 20],
  ['Münster', 51.9502139,7.4840156, 0, 20],
  ['Euskirchen', 50.6318631,6.7525532, 10, 20],
  ['Kleve', 51.7987152,6.0708277, 0, 20],
  ['Steinfurt', 52.1379305,7.2882413, 0, 20],
  ['Soest', 51.574594,8.0097005, 10, 20],
  ['Warendorf', 51.9519575,7.8395528, 10, 20],
  ['Mönchengladbach', 51.1656814,6.343774, 10, 20],
  ['Düsseldorf', 51.2385861,6.6742686, 0, 20],
  ['Coesfeld', 51.9171754,7.0883291, 10, 20],
  ['Herford', 52.1139768,8.5857976, 0, 20],
  ['Detmold', 51.9286172,8.806302, 10, 20],
  ['Minden', 52.3060825,8.8251288, 0, 20],
  ['Höxter', 51.768414,9.2854334, 10, 20],
  ['Meschede', 51.3307622,8.1652671, 0, 20],
  ['Schmallenberg', 51.1906793,8.2397214, 10, 20],
  ['Gütersloh', 51.9166629,8.3256733, 0, 20],
  ['Borken', 51.8370129,6.6462734, 0, 20],
  ['Olpe', 51.0381303,7.8190085, 0, 20],
  ['Iserlohn', 51.3877728,7.5945841, 10, 20],
  ['Wipperfürth', 51.1171131,7.3192596, 10, 20],
  ['Viersen', 51.2695468,6.2910058, 10, 20],
  ['Düren', 50.7993885,6.3919911, 10, 20],
  ['Heinsberg', 51.0593913,6.0565805, 0, 20],
  ['Wesel', 51.6700166,6.5170336, 0, 20],
  ['Hamm', 51.6613332,7.7660211, 0, 20],
  ['Recklinghausen', 51.6021123,7.1799103, 10, 20],
  ['Bottrop', 51.5710273,6.8458121, 10, 20],
  ['Bochum', 51.4709935,7.1555183, 10, 20],
  ['Siegburg', 50.8039672,7.2073341, 10, 20]
];

const thueringen = [
  ['Erfurt', 50.9806204,11.0268643, 0, 20],
  ['Nordhausen', 51.4741127,10.7595783, 10, 20],
  ['Eisenach', 50.9837854,10.3103343, 0, 20],
  ['Gera', 50.8821704,12.0723133, 0, 20],
  ['Altenburg', 50.9881824,12.4246393, 0, 20],
  ['Suhl', 50.6103764,10.6682563, 0, 20],
  ['Weimar', 50.9791154,11.3111193, 10, 20],
  ['Jena', 50.9276764,11.5697143, 0, 20],
  ['Gotha', 50.9448824,10.6735773, 10, 20],
  ['Ilmenau', 50.6887994,10.9014223, 10, 20],
  ['Heiligenstadt', 51.3702275,10.1426391, 10, 20],
  ['Sonderhausen', 51.3526268,10.6441755, 10, 20],
  ['Sömmerda', 51.1728267,11.0693319, 10, 20],
  ['Rudolstadt', 50.7076546,11.2256692, 0, 20],
  ['Meiningen', 50.5762977,10.3759493, 10, 20],
  ['Remptendorf', 50.5422712,11.5250158, 0, 20],
  ['Hildburghausen', 50.4372995,10.6652158, 0, 20],
  ['Bad Salzungen', 50.7908345,10.1819484, 10, 20],
  ['Langenwetzendorf', 50.6660903,12.0270899, 10, 20],
  ['Stadtroda', 50.8607233,11.7020395, 10, 20],
  ['Sonneberg', 50.3675115,11.1024225, 10, 20],
  ['Neumark', 51.0894925,11.235478, 10, 20],
  ['Mülhausen', 51.2389409,10.3888035,0,20]
];

const niedersachsen = [
  ['Hannover', 52.3762953,9.7036623, 0, 20],
  ['Wolfsburg', 52.4251943,10.7575703, 0, 20],
  ['Göttingen', 51.5409713,9.8920503, 0, 20],
  ['Meppen', 52.6931652,7.2679263, 10, 20],
  ['Braunschweig', 52.2681763,10.4975393, 0, 20],
  ['Salzgitter', 52.1379823,10.3534723, 10, 20],
  ['Peine', 52.3193403,10.2116993, 10, 20],
  ['Lüneburg', 53.2472702,10.3935003, 0, 20],
  ['Cuxhaven', 53.8480411,8.6170683, 0, 20],
  ['Osnabrück', 52.2756513,8.0237113, 0, 20],
  ['Northeim', 51.7155625,9.934515, 10, 20],
  ['Goslar', 51.9250886,10.413529, 0, 20],
  ['Hildesheim', 52.1437012,9.8746267, 10, 20],
  ['Holzminden', 51.7870054,9.439489, 10, 20],
  ['Hameln', 52.1065891,9.2904613, 0, 20],
  ['Schaumburg', 52.2745452,9.0657923, 10, 20],
  ['Helmstedt', 52.2313837,10.9260724, 10, 20],
  ['Gifhorn', 52.5086342,10.4555778, 10, 20],
  ['Uelzen', 52.9602145,10.5135458, 10, 20],
  ['Dannenberg', 53.0990388,11.0200932, 10, 20],
  ['Celle', 52.645725,10.0278507, 0, 20],
  ['Harburg', 53.317264,9.7359898, 10, 20],
  ['Soltau', 53.0038487,9.7749195, 10, 20],
  ['Walsrode', 52.8385818,9.4051581, 10, 20],
  ['Nienburg', 52.6401547,9.1658567, 0, 20],
  ['Stade', 53.614787,9.3923146, 10, 20],
  ['Diepholz', 52.6109087,8.3007084, 0, 20],
  ['Syke', 52.9047516,8.7720765, 10, 20],
  ['Bramsche', 52.4201069,7.9304776, 10, 20],
  ['Nordhorn', 52.4436675,7.0310709, 0, 20],
  ['Cloppenburg', 52.8595602,7.9643219, 0, 20],
  ['Vechta', 52.7439495,8.2193083, 10, 20],
  ['Wolfenbüttel', 52.1722578,10.4682938, 10, 20],
  ['Rotenburg', 53.1220945,9.3010226, 0, 20],
  ['Bremervörde', 53.5008293,9.1098168, 10, 20],
  ['Osterholz-Scharmbeck', 53.2549737,8.7350886, 10, 20],
  ['Geestland', 53.6279264,8.6118908, 10, 20],
  ['Delmenhorst', 53.0480162,8.5750386, 10, 20],
  ['Oldenburg', 53.1441014,8.1506954, 0, 20],
  ['Westerstede', 53.2587017,7.8576775, 10, 20],
  ['Nordenham', 53.4958312,8.3896738, 10, 20],
  ['Verden', 52.9405869,9.167228, 10, 20],
  ['Emden', 53.3645076,7.0853064, 10, 20],
  ['Aurich', 53.4836847,7.470394, 0, 20],
  ['Wittmund', 53.5980913,7.612414, 10, 20],
  ['Varel', 53.3870508,8.0499738, 10, 20],
  ['Wilhelmshaven', 53.5700299,8.0122769, 0, 20],
  ['Papenburg', 53.059007,7.3379586, 10, 20],
  ['Wittingen', 52.6997176,10.6252679, 10, 20],
  ['Leer', 53.2352632,7.4408803, 10, 20]
];

const germany = [
  ['Hamburg', 53.5584902,9.7877416, 6, 20],
  ['Düsseldorf', 51.2384339,6.7443112, 6, 20],
  ['Stuttgart', 48.7791878,9.1071762, 6, 20],
  ['München', 48.1548895,11.4717967, 6, 20],
  ['Kiel', 54.3417926,10.0556381, 6, 20],
  ['Mainz', 49.9653659,8.1724916, 0, 20],
  ['Saarbrücken', 49.2471361,6.9124993, 0, 20],
  ['Erfurt', 50.9853195,10.9452965, 6, 20],
  ['Dresden', 51.0768128,13.7025467, 6, 20],
  ['Magdeburg', 52.1259454,11.571798, 6, 20],
  ['Bremen', 53.1199492,8.5962058, 6, 20],
  ['Schwerin', 53.615894,11.3307936, 0, 20],
  ['Potsdam', 52.4283409,12.9573733, 0, 20],
  ['Hannover', 52.3796457,9.6914325, 0, 20],
  ['Berlin', 52.5067614,13.2846517, 6, 20]
];

const germanStates = [
  ['Baden-Württemberg', 48.832237, 8.602314, 0, 20],
  ['Bayern', 48.9468951, 11.4232202, 0, 20],
  ['Berlin', 52.5327, 13.368151, 0, 20],
  ['Brandenburg',52.147052, 13.029619, 0, 20],
  ['Bremen', 53.112144339, 8.78623450, 0, 20],
  ['Hamburg', 53.554568183, 10.027208746, 0, 20],
  ['Hessen', 50.804256, 8.659773, 0, 20],
  ['Mecklenburg-Vorpommern', 53.7531202, 12.53758385, 0, 20],
  ['Niedersachsen', 52.661918, 9.468131, 0, 20],
  ['Nordrhein-Westfalen', 51.496297, 7.219533, 0, 20],
  ['Rheinland-Pfalz', 50.179671, 6.654691, 0, 20],
  ['Saarland',49.386627, 6.9570273, 0, 20],
  ['Sachsen-Anhalt', 51.843087, 11.056544, 0, 20],
  ['Sachsen', 51.155872, 13.303364, 0, 20],
  ['Schleswig-Holstein', 54.261276, 9.109166, 0, 20],
  ['Thüringen', 50.9029749, 11.0304845, 0, 20]
];

const sachsen = [
  ['Dresden', 51.0494432,13.7334366, 0, 20],
  ['Görlitz', 51.1500853,14.9637023, 8, 20],
  ['Bautzen', 51.1816963,14.4218987, 0, 20],
  ['Hoyerswerder', 51.4379641,14.2473133, 0, 20],
  ['Bad Muskau', 51.5543305,14.7002916, 8, 20],
  ['Pirna', 50.9619173,13.940447, 8, 20],
  ['Meißen', 51.1623381,13.4750381, 8, 20],
  ['Riesa', 51.3035815,13.2862105, 0, 20],
  ['Wurzen', 51.3365186,12.7873089, 8, 20],
  ['Leipzig', 51.3400561,12.3720825, 0, 20],
  ['Schkeuditz', 51.4082775,12.2243743, 8, 20],
  ['Grimma', 51.2362572,12.7195528, 0, 20],
  ['Freiberg', 50.9152364,13.3373005, 8, 20],
  ['Chemnitz', 50.8274125,12.9178671, 0, 20],
  ['Zwickau', 50.7195214,12.4735761, 0, 20],
  ['Aue', 50.5903699,12.6984517, 8, 20],
  ['Plauen', 50.49786,12.1325946, 0, 20],
  ['Löbau', 51.0977316,14.6653385, 10, 20],
  ['Niesky', 51.2932115,14.8291062, 10, 20],
  ['Boxberg', 51.403097,14.5768897, 10, 20],
  ['Kamenz', 51.2745415,14.1004518, 10, 20],
  ['Pulsnitz', 51.1838873,14.0134906, 10, 20],
  ['Bischofswerda', 51.1244011,14.1791052, 10, 20],
  ['Bad Schandau', 50.9202378,14.1521438, 10, 20],
  ['Glashütte', 50.8508843,13.7741225, 10, 20],
  ['Altenberg', 50.7639343,13.757821, 10, 20],
  ['Nossen', 51.0584539,13.2951653, 10, 20],
  ['Großenhain', 51.2915597,13.5295185, 10, 20],
  ['Torgau', 51.5559912,12.9902679, 10, 20],
  ['Delitzsch', 51.5252397,12.3409304, 10, 20],
  ['Borna', 51.1244603,12.4914474, 10, 20],
  ['Mittweida', 50.9853965,12.9719318, 10, 20],
  ['Glauchau', 50.8150481,12.5427199, 10, 20],
  ['Klingenthal', 50.3708745,12.4665545, 10, 20],
  ['Meerane', 50.8469173,12.4658345, 10, 20],
  ['Eibenstock', 50.4944725,12.5985627, 10, 20],
  ['Marienberg', 50.6491887,13.1614853, 10, 20]
];

const brandenburg = [
  ['Berlin', 52.5158412,13.3912353, 8, 10],
  ['Prenzlau', 53.3169004,13.8609307, 0, 20],
  ['Templin', 53.1166877,13.4968131, 8, 20],
  ['Schwedt', 53.0642075,14.2706866, 0, 20],
  ['Wittstock', 53.2044433,12.5517522, 0, 20],
  ['Neuruppin', 52.9151834,12.7977588, 0, 20],
  ['Oranienburg', 52.7533497,13.2360739, 8, 20],
  ['Brandenburg', 52.4120599,12.5248709, 8, 20],
  ['Potsdam', 52.3908513,13.062643, 0, 20],
  ['Frankfurt', 52.3463017,14.5463436, 0, 20],
  ['Eisenhüttenstadt', 52.1439979,14.6419972, 8, 20],
  ['Cottbus', 51.7568778,14.3324318, 0, 20],
  ['Beelitz', 52.2379984,12.9652621, 8, 20],
  ['Dahme', 51.8680336,13.4264768, 0, 20],
  ['Herzberg', 51.6803178,13.2086144, 0, 20],
  ['Lübbenau', 51.8639467,13.9528065, 8, 20],
  ['Strausberg', 52.569278,13.8763382, 0, 20],
  ['Eberswalde', 52.836698,13.7831417, 0, 20],
  ['Halbe', 52.1100388,13.6959162, 0, 20],
  ['Bad Belzig', 52.1434568,12.5884305, 0, 20],
  ['Wittenberge', 52.9948508,11.7523414, 0, 20]
];

export default {
  germany,
  germanStates,
  berlin,
  hamburg,
  nrw,
  thueringen,
  niedersachsen,
  sachsen,
  brandenburg
};